<div *ngIf='componentReady' class='Integrations container d-flex flex-column m-auto p-5'>
  <div class='Integrations__title d-flex justify-content-center'>
    <p>Retreva&reg; offers synchronization of contacts from {{ userSession.integration.name }}.</p>
  </div>
  <div class='Integrations__body d-flex mt-3 flex-column'>
    <div *ngFor='let field of fields' class='Integrations__body__row mb-3 row'>
      <div class='Integrations__body__row__label col col-12 col-md-6'>
        <p>{{ integrationData.fields[field].label }}</p>
      </div>
      <div [formGroup]='formGroup' class='Integrations__body__row__control col col-12 col-md-6'>
        <ng-container [ngSwitch]='integrationData.fields[field].control'>
          <ng-container *ngSwitchCase="'text'">
            <app-text-field [formControlName]='field'
                            [placeholder]='integrationData.fields[field].label'></app-text-field>
          </ng-container>
          <ng-container *ngSwitchCase="'list'">
            <app-select [formControlName]='field'
                        [items]='getDynamicList(integrationData.fields[field].control_source, integrationData.fields[field].type)'
                        [label]='integrationData.fields[field].label'></app-select>
          </ng-container>
          <ng-container *ngSwitchCase="'checkbox'">
            <mat-checkbox [formControlName]='field'></mat-checkbox>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div class='Integrations__footer row'>
      <div class='col col-12 col-md-6 offset-md-6'>
        <app-button [Click]='submitButtonProperties.onClick' [color]='submitButtonProperties.color'
                    [observeApi]='true' [size]='submitButtonProperties.size'
                    [text]='submitButtonProperties.text'></app-button>
      </div>
    </div>
  </div>
</div>
